import { ReactNode, createContext } from 'react';
import { PathProps } from '../@types/types';
import { extractPathProps } from './extract-path-props';

export const PathContext = createContext<PathProps>(null);

export function PathProvider({ path, children }: { path: string; children: ReactNode }) {
  return <PathContext.Provider value={extractPathProps(path)}>{children}</PathContext.Provider>;
}
